export { default } from "./QuizImage";
